export default __webpack_public_path__ + "static/media/HistoricChangeMotive.a39228a0.svg";